$(document).ready(function () {
    window.valideKey = function (evt) {
        // El código es la representación decimal ASCII de la tecla presionada.
        var code = (evt.which) ? evt.which : evt.keyCode;

        if (code == 8) { // espacio.
            return true;
        } else if (code >= 48 && code <= 57) { // es un numero
            return true;
        } else { // other keys.
            return false;
        }
    }

    window.loading_small_small = function (div) {
        if ($("#" + div).length > 0) {
            document.getElementById(div).innerHTML = '<center><img src="' + window.location.origin + '/images/loading.gif" border="0" width="90px" /></center>';
        }
    }

    window.validarSoloNumeros = function(input) {
        input.value = input.value.replace(/[^0-9]/g, '');
    };

    window.validarSoloLetrasYEspacio = function(input) {
        input.value = input.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s´]/g, '');
    }

});



